import React from 'react';
import { SmallText } from '../ui/Typography';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useDroppable } from '@dnd-kit/core';
import SiteMapModel from '../../steps/Sitemap/models/SiteMapModel';
import ExternalTreeNode from './components/ExternalTreeNode';

const ExternalSitemapTree: React.FC = observer(() => {
  const { t } = useTranslation();
  const { setNodeRef } = useDroppable({
    id: 'external-tree-droppable',
    data: {
      type: 'external-container'
    }
  });

  const oldWebsitePages = SiteMapModel.treeSiteMap.filter(
    (node) => node.parent === SiteMapModel.SITEMAP_ROOT_EXTERNAL
  );


  return (
    <div className="old-sitemap" ref={setNodeRef}>
      <div className="bg-white rounded-lg">
        {oldWebsitePages.length > 0 ? (
          <div className="old-pages-tree">
            {oldWebsitePages.map((node, index) => (
              <ExternalTreeNode
                key={node.id}
                node={node}
                level={0}
                allNodes={SiteMapModel.treeSiteMap}
              />
            ))}
          </div>
        ) : (
          <SmallText style={{ color: 'rgba(0,0,0,0.45)', fontStyle: 'italic' }}>
            {t('No old website pages found.')}
          </SmallText>
        )}
      </div>
    </div>
  );
});

export default ExternalSitemapTree;
